export class ItemRatingModel {
    UserId: string;
    Rating: number;
    ItemId: string;
    Comment: string;

    constructor() {
        this.UserId = '';
        this.Rating = 0;
        this.ItemId = '';
        this.Comment = '';
    }
}
